<nz-spin [nzSpinning]="loading()">
  @if (comments().length === 0 && !loading()) {
    <nz-empty
      [nzNotFoundContent]="'visitComments.noComments' | translate"
    ></nz-empty>
  }

  <div class="comments-list">
    @for (comment of comments(); track comment.id) {
      <div class="comment-item" [class.pinned]="comment.isPinned">
        <div class="comment-header">
          <div class="comment-author">
            <nz-avatar
              [nzText]="getInitials(comment.createdBy?.fullName)"
              [nzSize]="32"
              nzShape="circle"
              style="background-color: #1890ff; vertical-align: middle;"
            ></nz-avatar>
            <div class="author-info">
              <span class="author-name">{{ comment.createdBy?.fullName || '—' }}</span>
              <span class="comment-date">{{ comment.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>
          </div>

          <div class="comment-actions">
            @if (comment.isPinned) {
              <button
                nz-button
                nzType="text"
                nzSize="small"
                nz-tooltip
                [nzTooltipTitle]="'visitComments.unpin' | translate"
                (click)="unpinComment(comment)"
              >
                <span nz-icon nzType="pushpin" nzTheme="fill" style="color: #1890ff;"></span>
              </button>
            } @else {
              <button
                nz-button
                nzType="text"
                nzSize="small"
                nz-tooltip
                [nzTooltipTitle]="'visitComments.pin' | translate"
                (click)="pinComment(comment)"
              >
                <span nz-icon nzType="pushpin" nzTheme="outline"></span>
              </button>
            }

            @if (!comment.isFromDescription) {
              <button
                nz-button
                nzType="text"
                nzSize="small"
                (click)="startEdit(comment)"
              >
                <span nz-icon nzType="edit"></span>
              </button>
              <button
                nz-button
                nzType="text"
                nzSize="small"
                nzDanger
                nz-popconfirm
                [nzPopconfirmTitle]="'visitComments.deleteConfirm' | translate"
                (nzOnConfirm)="deleteComment(comment)"
              >
                <span nz-icon nzType="delete"></span>
              </button>
            }
          </div>
        </div>

        <!-- Tags -->
        <div class="comment-tags">
          @if (comment.isFromDescription) {
            <nz-tag nzColor="purple">{{ 'visitComments.fromDescription' | translate }}</nz-tag>
          }
          @if (comment.isPinned) {
            <nz-tag nzColor="blue">{{ 'visitComments.pinned' | translate }}</nz-tag>
          }
          @if (comment.booking?.employee?.user?.fullName) {
            <nz-tag nzColor="cyan">{{ comment.booking?.employee?.user?.fullName }}</nz-tag>
          }
          @if (comment.bookingService?.service?.name) {
            <nz-tag nzColor="geekblue">{{ comment.bookingService?.service?.name }}</nz-tag>
          }
        </div>

        <!-- Comment text or edit form -->
        @if (editingCommentId === comment.id) {
          <div class="edit-form">
            <textarea
              nz-input
              [(ngModel)]="editingText"
              [nzAutosize]="{ minRows: 2, maxRows: 6 }"
            ></textarea>
            <div class="edit-actions">
              <button nz-button nzType="primary" nzSize="small" (click)="saveEdit(comment)">
                <span nz-icon nzType="check"></span>
              </button>
              <button nz-button nzSize="small" (click)="cancelEdit()">
                <span nz-icon nzType="close"></span>
              </button>
            </div>
          </div>
        } @else {
          <div class="comment-text">{{ comment.text }}</div>
        }
      </div>
    }
  </div>

  <!-- New comment form -->
  <div class="new-comment-form">
    <div class="form-tags">
      <nz-select
        class="tag-select"
        [(ngModel)]="selectedBookingId"
        (ngModelChange)="onBookingChange($event)"
        [nzPlaceHolder]="'visitComments.selectBooking' | translate"
        nzAllowClear
        nzSize="small"
      >
        @for (booking of visitAddFacade.bookings(); track booking.id) {
          <nz-option
            [nzValue]="booking.id"
            [nzLabel]="(booking.employee?.user?.fullName || '—') + ' (' + (booking.startTime || '—') + ')'"
          ></nz-option>
        }
      </nz-select>

      @if (availableBookingServices().length > 0) {
        <nz-select
          class="tag-select"
          [(ngModel)]="selectedBookingServiceId"
          [nzPlaceHolder]="'visitComments.selectService' | translate"
          nzAllowClear
          nzSize="small"
        >
          @for (bs of availableBookingServices(); track bs.id) {
            <nz-option
              [nzValue]="bs.id"
              [nzLabel]="bs.service?.name || '—'"
            ></nz-option>
          }
        </nz-select>
      }
    </div>

    <div class="form-input">
      <textarea
        nz-input
        [(ngModel)]="newCommentText"
        [placeholder]="'visitComments.placeholder' | translate"
        [nzAutosize]="{ minRows: 2, maxRows: 4 }"
      ></textarea>
      <button
        nz-button
        nzType="primary"
        [nzLoading]="submitting()"
        [disabled]="!newCommentText.trim()"
        (click)="submitComment()"
      >
        <span nz-icon nzType="send"></span>
      </button>
    </div>
  </div>
</nz-spin>
